/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {startLoadding, stopLoading} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {GetAllData as businessName} from '../../BusinessName/BusinessNameSlice/BusinessSlice'
import {getDedicatedNumberList} from '../../DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'
const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  CustomNumberList: [],
}

const RouteUrl = {
  GetAllData: 'customNumber',
  GetData: '',
  EditData: '',
  DeleteData: 'customNumber/delete',
  CreateData: 'customNumber/add',
  setDefault: 'customNumber/setDefault',
  otpVerify: 'customNumber/verifyCustomNumber',
}

const thunkName = {
  GetAllData: 'customNumber-GetAllData',
  GetData: '',
  EditData: '',
  CreateData: 'customNumber-RequestCustomNumber',
  setDefaultCustomNumber: 'customNumber-singleChat',
  otpVerify: 'customNumber-OTP',
}

export const GetAllData: any = createAsyncThunk(thunkName.GetAllData, async () => {
  const response = await axios.get(`${API_URL}${RouteUrl.GetAllData}`, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  return response.data
})

export const DeleteData: any = createAsyncThunk('DeleteData', async (data, thunkApi) => {
  const response = await axios.put(`${API_URL}${RouteUrl.DeleteData}`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status == true && toast.success(response.data.message)
  }

  thunkApi.dispatch(GetAllData())
})
export const CreateData: any = createAsyncThunk('CreateData', async (data: any, thunkApi) => {
  thunkApi.dispatch(startLoadding())
  const response = await axios.post(`${API_URL}${RouteUrl.CreateData}`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status == true && toast.success(response.data.message)
  }
  thunkApi.dispatch(stopLoading())
  thunkApi.dispatch(GetAllData())
})
export const OTPVerify: any = createAsyncThunk(
  'CustomNumber-otpverify',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}${RouteUrl.otpVerify}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetAllData())
  }
)
export const setDefaultCustomNumber: any = createAsyncThunk(
  'setDefault/bussinessName',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.put(`${API_URL}${RouteUrl.setDefault}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetAllData())
    thunkApi.dispatch(businessName())
    thunkApi.dispatch(getDedicatedNumberList())
  }
)

const CustomNumber = createSlice({
  name: 'CustomNumber',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetAllData.fulfilled, (state, action) => {
      return {...state, CustomNumberList: action?.payload}
    })
  },
})

export const getCustomNunberList = (state: any) => state?.CustomNumber?.CustomNumberList?.data
export default CustomNumber.reducer
